module.exports = __webpack_public_path__ + "static/img/title.8ce5a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/study/title.png
// module id = 84jB
// module chunks = 0